<template>
  <FsLightbox
    type="image"
    :toggler="toggler"
    :sources="payload"
    :source-index="sourceIndex"/>
</template>

<script>
import FsLightbox from 'fslightbox-vue';

export default {
  props: {
    sources: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    toggler: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    sourceIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    type: {
      type: String,
      required: false,
      default: 'image',
    },
  },
  components: {
    FsLightbox,
  },
  computed: {
    payload() {
      return this.sources.map((id) => `${process.env.VUE_APP_BASE_URL}/attach/${id}`);
    },
  },
};
</script>
